import React, {FC} from 'react';
import ClockIcon from "../../../../media/icons/clock.svg?react";
import {formatDate} from "../../../../utils/helpers/dateHelpers/dateHelpers";
import {FlyRoute} from "../../flyRoute/FlyRoute";
import {
  FlightDrawerDetailsHeader,
  FlightDrawerDetailsTitle,
  FlightDrawerDetailsTitleWrapper,
  FlightDrawerDetailsUpdatedTime,
  FlightDrawerDetailsWrapper,
} from "./FlightDrawerDetailsStyledComponents";
import {IEmptyLeg} from "../../../../store/reducers/emptyLegsReducer/emptyLegsReducerTypes";
import {ISearchedEmptyLeg} from "../../../../store/reducers/searchReducer/searchReducerTypes";
import {useAppSelector} from "../../../../store/store";
import {defineMessages, useIntl} from "react-intl";
import {useIsMobile} from "../../../../hooks/useWindowSize";
import {OrderTypeShield} from "../../orderType/OrderTypeShield";
import {OrderTypeEnum} from "../../../../store/reducers/chartererRequestsReducer/chartererRequestsReducerTypes";

const FlightDrawerEmptyLegDetailsMessages = defineMessages({
  flyDuration: {
    id: "flightDrawerEmptyLegDetails.flyDuration",
    defaultMessage: "Flight duration",
  },
  title: {
    id: "flightDrawerEmptyLegDetails.title",
    defaultMessage: "Route details",
  },
  updated: {
    id: "flightDrawerEmptyLegDetails.updated",
    defaultMessage: "Updated",
  },
})

interface IFlightDrawerEmptyLegDetails {
  emptyLeg: IEmptyLeg | ISearchedEmptyLeg;
}

export const FlightDrawerEmptyLegDetails: FC<IFlightDrawerEmptyLegDetails> = ({
                                                                                emptyLeg,
                                                                              }) => {
  const intl = useIntl();
  const isMobile = useIsMobile();
  const {offset} = useAppSelector(state => state.user.oneItemObject.item.timezone) || {offset: 0};

  return (
    <FlightDrawerDetailsWrapper>
      <FlightDrawerDetailsHeader>
        <FlightDrawerDetailsTitleWrapper>
          <FlightDrawerDetailsTitle>{intl.formatMessage(FlightDrawerEmptyLegDetailsMessages.title)}</FlightDrawerDetailsTitle>
          {emptyLeg.dateModified && !isMobile && <FlightDrawerDetailsUpdatedTime>
            <ClockIcon/>
            <div>{intl.formatMessage(FlightDrawerEmptyLegDetailsMessages.updated)}{" "}
              <span>{formatDate(emptyLeg.dateModified, offset, "datetime_short_year")}</span></div>
          </FlightDrawerDetailsUpdatedTime>}
        </FlightDrawerDetailsTitleWrapper>
        <OrderTypeShield type={OrderTypeEnum.EMPTY_LEG} styleType={'fill'} />
      </FlightDrawerDetailsHeader>

      <FlyRoute airportFrom={emptyLeg.airportFrom}
                airportTo={emptyLeg.airportTo}
                dateFrom={emptyLeg.departureDate}
                dateTo={emptyLeg.arrivalDate}
                availableFromDate={emptyLeg.availableFromDate}
                availableToDate={emptyLeg.availableToDate}
                flyHoursDuration={emptyLeg.flyHours}
                flyMinutesDuration={emptyLeg.flyMinutes}
                distance={emptyLeg.flyDistance}
                pax={emptyLeg.plane.maxPassengers}
      />
    </FlightDrawerDetailsWrapper>
  );
};
